import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  user: {},
  capabilities: [],
  modules: []
}

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      }
      break
    case LOGIN_SUCCESS:
      let capabilities = []
      let modules = []
      if(Array.isArray(action.payload?.enum_admin_additional_role?.access)){
        capabilities = action.payload.enum_admin_additional_role.access
      }
      if(Array.isArray(action.payload?.enum_admin_additional_role?.modules)){
        modules = action.payload.enum_admin_additional_role.modules
      }
      state = {
        ...state,
        loading: false,
        user: action.payload,
        capabilities,
        modules
      }
      break
    case LOGOUT_USER:
      state = { ...state }
      break
    case LOGOUT_USER_SUCCESS:
      state = { ...state }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default login
